// The solved chime, synthesised with WebAudio (no files to load). Moves and
// captures are silent. On by default, off with one toggle (spec §8.5).
import { getPrefs } from "./prefs";

let ctx: AudioContext | null = null;

function audio(): AudioContext | null {
  if (!getPrefs().sound) return null;
  try {
    ctx ??= new AudioContext();
    if (ctx.state === "suspended") void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

function tone(freq: number, start: number, length: number, gain: number, type: OscillatorType = "sine") {
  const a = audio();
  if (!a) return;
  const osc = a.createOscillator();
  const g = a.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  const t = a.currentTime + start;
  g.gain.setValueAtTime(0, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.005);
  g.gain.exponentialRampToValueAtTime(0.0001, t + length);
  osc.connect(g).connect(a.destination);
  osc.start(t);
  osc.stop(t + length + 0.02);
}

/** A short rising chime. */
export function playSolved() {
  [523.25, 659.25, 783.99].forEach((f, i) => tone(f, 0.05 + i * 0.09, 0.45, 0.12));
}
